import { Footer, Header } from '../components';
import { Outlet } from 'react-router-dom';

const Produkte = () => {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};

export default Produkte;
